import RenderInfo from 'components/RenderInfo';
import React from 'react';
import { secondsToMinutes } from 'utils';
import CartAddress from './address';
import styles from './index.module.scss';
import CartPaymentMethod from './paymentMethod';

const BasicDetails = (props) => {
  const { details, details: { nextRoutedDeliveryAvailableDays = '', duration = '', distance = '', selectedAddress = {}} = {}, quoteCartFn } = props;

  return <div className={styles['basic-details-section']}>
    <div className={styles['basic-info']}>
      <div className={styles['info']}>
        <RenderInfo heading="Cart Id" value={details.objectId} />
        <RenderInfo heading="User Id" value={details.user?.objectId} link={`/users/${details.user?.objectId}`} />
        <RenderInfo heading="Created By Source" value={details.createdBySource} />
        <RenderInfo heading="Processed By Source" value={details.processedBySource} />
        <RenderInfo heading="Status" value={details.status} />
        {distance && <RenderInfo heading="Distance" value={`${distance?.toFixed(2)} miles`} />}
        {duration && <RenderInfo heading="Duration" value={`${secondsToMinutes(duration)} minutes`} />}
        <RenderInfo heading="Exempt delivery charges" value={details.exemptDeliveryCharges} type='boolean' />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="Delivery Charges" value={details.deliveryCharges} type="currency" />
        <RenderInfo heading="Delivery Taxes" value={details.deliveryTaxes} type="currency" />
        <RenderInfo heading="Taxes" value={details.taxes} type="currency" />
        <RenderInfo heading="Discount Amount" value={details.discountAmount} type="currency" />
        <RenderInfo heading="Sub Total" value={details.subtotals} type="currency" />
        <RenderInfo heading="Total" value={details.total} type="currency" />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="Created At" value={details.createdAt} type='date' />
        <RenderInfo heading="Updated At" value={details.updatedAt} type='date' />
        {nextRoutedDeliveryAvailableDays?.length > 0 && <RenderInfo heading="Next routed delivery available days" 
          value={details?.nextRoutedDeliveryAvailableDays?.join(', \n')}
          containerClass={styles['nextRoutedDeliveryAvailableDays']}
        />}
        <CartAddress user={details?.user} details={details} quoteCartFn={quoteCartFn} />
      </div>
    </div>
    <div className={styles['section-header']}>
      <div className={styles['section-heading']}>Payment Method</div>
    </div>
    <CartPaymentMethod details={details} user={details?.user} quoteCartFn={quoteCartFn} />
  </div>;
};

export default BasicDetails;